import React, { FC,memo} from 'react';
import { IOrder} from '@pages/Deliveries/context/orders';
import { OrderCard } from '../OrderCard';

interface OrderListItemProps extends IOrder {
  sequence?: number;
  isTestRestaurant?: boolean;
}

const OrderListItem: FC<OrderListItemProps> = ({
  reference,
  customer,
  courier,
  payment,
  hasAlcohol,
  sequence,
  expectedDeliveryTime,
  status,
  updateDate,
  uuid,
  hash
}) => {

  return (
    <OrderCard cardItems={{reference,courier,customer,status,hasAlcohol,expectedDeliveryTime,uuid,hash,sequence,updateDate,payment}}  />
  );
};

export default memo(OrderListItem);
